<div class="form-parent">
  <kgrid
    apiName="{{ apiName }}"
    [noAutoFitColumns]="true"
    label="{{ label }}"
    name="{{ apiName }}"
    [areaName]="areaName"
    [paging]="false"
    [IgnoreDeletePermission]="IgnoreDelete"
    [deleteMessage]="deleteMessage"
    [inputEditorform]="inputEditorform"
    [columns]="columns"
    [isAdd]="isAdd"
    [isEdit]="isEdit"
    [isDelete]="isDelete">
  </kgrid>
</div>
